module.exports = __webpack_public_path__ + "img/DISA-Signature.52876046.png";